<template>
  <div
    class="
      $color/session
      layout/height:100%
      layout/relative
    "
    role="alert"
    aria-busy="true"
    >
    <div
      class="
        $typography/size:medium
        layout/absolute:center
        layout/height:cap:3
        layout/width:cap:3
      "
      >
      <p
        class="
          $typography/size:large
          typography
        "
        >
        <icon
          icon-name="icon__spinner--16.svg"
          class-name="
            component__spinner
            layout/absolute
            layout/bottom:0%
            layout/height:100%
            layout/left:0%
            layout/right:0%
            layout/top:0%
            layout/width:100%
            typography/icon
          "
        />
      </p>
    </div>
  </div>
</template>

<script>
import icon from 'Components/icons/icon.vue';
export default {
  name: 'spinner',
  components: {
    icon,
  }
};
</script>

<style>
  .component__spinner {
    --timing: 1.4s;
    --offset: 250px;

    animation: rotator var(--timing) linear infinite;
    transform-origin: 50% 50%;
    transform: rotate(0deg);
  }

  @keyframes rotator {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  .component__spinner > circle {
    animation: dash var(--timing) ease-in-out infinite;
    stroke-dasharray: calc(0.4 * var(--offset)), var(--offset);
    stroke-dashoffset: 0;
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1px, var(--offset);
      stroke-dashoffset: calc(0.0 * var(--offset));
    }
    50% {
      stroke-dasharray: calc(0.5 * var(--offset)), var(--offset);
      stroke-dashoffset: calc(-0.075 * var(--offset));
    }
    100% {
      stroke-dasharray: calc(0.5 * var(--offset)), var(--offset);
      stroke-dashoffset: calc(-0.625 * var(--offset));
    }
  }
</style>
